import clsx from "clsx";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { IOption } from "models/Form";
import styles from "./style.module.scss";

interface IProps {
  onViewTypeChange: (value: string) => void;
  viewType: string;
  headerItems: Array<IOption & { link?: string }>;
  className?: string;
}

export default function SubHeader({
  viewType,
  headerItems,
  onViewTypeChange,
  className
}: Readonly<IProps>) {
  const { pathname } = useLocation();

  useEffect(() => {
    const selectedTab = headerItems.find((item) => item.link === pathname);
    onViewTypeChange(selectedTab?.value ?? headerItems[0].value);
  }, [pathname]);

  return (
    <div className={clsx(styles.headerSubTab, className)}>
      {headerItems.map((item) => {
        const isSelected = viewType === item.value;

        return (
          <Link
            key={item.id}
            to={item.link ?? ""}
            className={clsx(styles.headerSubTabLink, isSelected ? styles.active : "text-text")}
            onClick={() => onViewTypeChange(item.value)}>
            {item.label}
          </Link>
        );
      })}
    </div>
  );
}
